var localePt = {
  pt: {
    DEFAULT_CTA_LABEL: 'Vamos conversar',
    DEFAULT_TITLE: 'Acesse a Crehana com uma chamada',
    DEFAULT_DESCRIPTION: 'Insira seus dados e nós o aconselharemos com nossas melhores ofertas Premium.',
    CALL_CENTER_DIALOG_NAME: 'Nome',
    REQUIRED_FIELD: 'Campo obrigatório',
    MAX_CHARS: 'Máximo de 50 caracteres',
    PHONE_NUMBER: 'Número de celular'
  }
};
export default localePt;